import nodata from "../../../assets/images/common/nodata.png";

const Nodata = ({
  fromTransit = false,
  activty = false,
  globalData = false,
  release = false,
  tranistSelect = false,
}) => {
  return (
    <>
      <div className="no-records">
        <img className="no_found_img" src={nodata} />
        {activty ? (
          <>
            <p className="no_found_ptag">No activity recorded yet.</p>
            <p className="no_found_ptag">Start by adding an entry!</p>
          </>
        ) : globalData ? (
          <p className="no_found_ptag">
            <span style={{ fontWeight: 600, fontSize: "24px" }}>Oops!</span> We
            couldn’t find what you’re looking for.
          </p>
        ) : release ? (
          <p className="no_found_ptag">No entries yet</p>
        ) : fromTransit ? (
          <>
            <p className="no_found_ptag">No entries yet</p>
            <p className="no_found_ptag">
              Get started by selecting from location
            </p>
          </>
        ) : tranistSelect ? (
          <>
            <p className="no_found_ptag">No Selected items</p>
            <p className="no_found_ptag">Get started by adding one!</p>
          </>
        ) : (
          <>
            <p className="no_found_ptag">No entries yet</p>
            <p className="no_found_ptag">Get started by adding one!</p>
          </>
        )}
      </div>
    </>
  );
};
export default Nodata;
